import { CDN_HOST_URL, CDN_ENABLED } from '../constants/main';

export const useCdn =
    process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_CDN_HOST && CDN_ENABLED === 'true';

export const assetPathToCdnUrl = (path: string) => {
    return useCdn ? `${process.env.NEXT_PUBLIC_CDN_HOST}${path}` : path;
};
